import React, { useEffect, useState } from "react"
import { Button } from "../../../components/button/button"
import { ViewModeToggle } from "../../../components/view-mode-toggle"
import { IStickyBar } from "./model"
import { Tooltip } from "../../../components/tooltip"

import "./style.scss"

export function StickyBar({
    containerRef,
    toggleMobileView,
    mobileDisplay,
    submit,
    tooltipVisible,
    closeTooltip,
}: IStickyBar) {
    const [scrollPosition, setScrollPosition] = useState(false)
    const [width, setWidth] = useState(document.documentElement.clientWidth)

    useEffect(() => {
        const updatePosition = () => {
            const position =
                window.innerHeight - containerRef.current?.clientHeight >=
                containerRef.current?.getBoundingClientRect()?.top
            setScrollPosition(position)
        }
        window.addEventListener("scroll", updatePosition)
        updatePosition()
        return () => window.removeEventListener("scroll", updatePosition)
    }, [toggleMobileView, containerRef])

    useEffect(() => {
        const updateWidth = () => {
            if (width !== document.documentElement.clientWidth) {
                setWidth(document.documentElement.clientWidth)
            }
        }
        window.addEventListener("resize", updateWidth)
        updateWidth()
        return () => window.removeEventListener("resize", updateWidth)
    }, [document.documentElement.clientWidth])

    const left = (containerRef?.current?.offsetParent as HTMLElement)?.offsetLeft ?? 8
    const style: React.CSSProperties = scrollPosition
        ? {
              position: "absolute",
              bottom: "auto",
              width: `${width}px`,
              maxWidth: `${width}px`,
              MozBoxSizing: "border-box",
              WebkitBoxSizing: "border-box",
              boxSizing: "border-box",
              left: left === 0 ? 0 : -left,
          }
        : {}

    return (
        <React.Fragment>
            <div
                className={`sia-mobile-control`}
                style={{
                    ...style,
                }}
            >
                {tooltipVisible && <Tooltip closeTooltip={closeTooltip} />}
                <div className="flex">
                    <div className="mobile-toggle">
                        <ViewModeToggle
                            className="view-toggle"
                            active={mobileDisplay}
                            callback={toggleMobileView}
                            labelRight="Preview"
                            labelLeft="Edit"
                        />
                    </div>
                    <Button className="mobile-sign-up" onClick={() => submit("signup")}>
                        Sign up
                    </Button>
                </div>
            </div>
        </React.Fragment>
    )
}
